import { FOREIGN_CA, INVESTOR } from "constants/userTypes";

type SignupUserFlags = {
  user_type?: string | null;
  type?: string | null;
  is_any_service_user?: boolean;
  is_service_user?: boolean;
  is_foreign_ca?: boolean;
  is_public_user?: boolean;
};

export const isCustomerSignupUser = (user: SignupUserFlags = {}): boolean => {
  const isPractice =
    user.user_type === FOREIGN_CA || Boolean(user.is_foreign_ca);
  const isServiceTeam =
    Boolean(user.is_any_service_user) || Boolean(user.is_service_user);
  const isInvestor = user.type === INVESTOR || user.user_type === INVESTOR;

  return (
    !isPractice &&
    !isServiceTeam &&
    !isInvestor &&
    !Boolean(user.is_public_user)
  );
};
